export default __webpack_public_path__ + "static/media/_1058371.ee38d309.webp";